export enum AnnuityAlertType {
  ClientAnnuityLapseCriticalInterval = 'CLIENT_ANNUITY_LAPSE_CRITICAL_INTERVAL',
  ClientAnnuityPoaUrgencyInterval = 'CLIENT_ANNUITY_POA_URGENCY_INTERVAL',
  ClientAnnuitySurchargeUrgencyInterval = 'CLIENT_ANNUITY_SURCHARGE_URGENCY_INTERVAL',
  InternalAnnuityUrgencyInterval = 'INTERNAL_ANNUITY_URGENCY_INTERVAL',
  VendorAnnuityUrgencyInterval = 'VENDOR_ANNUITY_URGENCY_INTERVAL',
}
